import { createDictionaryFromDropdownOptions } from "@/utils/utils.js";

export const BASE_DATE_FORMAT = "hh:mm A, DD MMM YYYY";
export const BASE_TIME_FORMAT = "hh:mm A";
export const MONTH_TIME_FORMAT = "MMMM";
export const DATE_FORMAT_SHORT_WITH_TIME = "hh:mm A - DD MMM, YYYY";
export const BASE_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const InteractionChannelEnum = {
  EMAIL: "email",
  SMS: "sms",
  WHATSAPP: "whatsapp",
  SLACK: "slack",
  META: "meta",
  MSTEAMS: "msteams",
  WORDPRESS: "wordpress",
  WEB: "web",
  GOOGLECHAT: "googlechat",
  WEBFORM: "webform",
};

export const InteractionStatus2Enum = {
  VA_CLOSED: "VA-CLOSED",
  ONGOING: "ONGOING",
  TICKET: "TICKET",
  TICKET_CLOSED: "TICKET-CLOSED",
  TICKET_ON_HOLD: "TICKET-ON-HOLD",
  SOFT_ALERT: "SOFT-ALERT",
  UNKNOWN_USER_TICKET: "TICKET-UNKNOWN-USER",
};

export const DEFAULT_TICKET_STATUS_FILTERS = [
  InteractionStatus2Enum.TICKET,
  // InteractionStatus2Enum.TICKET_ON_HOLD,
];

// Corresponds to "All Tickets" tab on page 1 with default status filters.
export const DEFAULT_INBOX_VIEW_FILTERS = {
  // has_ticket: "true",
  // ticket_status: ["open", "reopened", "ongoing"],
  // status: DEFAULT_TICKET_STATUS_FILTERS,
  // page: "1",
  // limit: "10",
};

export const InteractionSourceEnum = {
  BOT: "BOT",
  ANNOUNCEMENT: "ANNOUNCEMENT",
  DIRECT_TICKET: "DIRECT_TICKET",
  TICKET_RESPONSE: "TICKET_RESPONSE",
  FOLLOWUP: "FOLLOWUP",
  UNKNOWN_USER_TICKET: "UNKNOWN_USER_TICKET",
};

export const TicketResponseStatusEnum = {
  LIVE: "LIVE",
  DRAFT: "DRAFT",
};

export const InteractionDepartmentEnum = {
  ALL: "ALL",
  ACCOUNTING: "ACCOUNTING",
  BUSINESS: "BUSINESS",
  DEVELOPMENT: "DEVELOPMENT",
  SUPPORT: "support",
  SALES: "sales",
  IT: "IT",
};

export const InteractionSortOptionEnum = {
  MOST_RECENT: "MOST_RECENT",
  CREATED_TIME_NEWEST_TO_OLDEST: "CREATED_TIME_NEWEST_TO_OLDEST",
  CREATED_TIME_OLDEST_TO_NEWEST: "CREATED_TIME_OLDEST_TO_NEWEST",
};

export const SortOderEnum = {
  ASC: "asc",
  DESC: "desc",
};

export const InteractionPageEnum = {
  ALL_TICKETS: "ALL_TICKETS",
  MY_TICKETS: "MY_TICKETS",
  MY_TEAMS: "MY_TEAMS",
  MY_DEPARTMENTS: "MY_DEPARTMENTS",
  MY_DRAFTS: "MY_DRAFTS",
  ALL_SOFT_ALERTS: "ALL_SOFT_ALERTS",
  MY_SOFT_ALERTS: "MY_SOFT_ALERTS",
  ALL_INTERACTIONS: "ALL_INTERACTIONS",
  VA_INTERACTIONS: "VA_INTERACTIONS",
  UNKNOWN_USER_TICKETS: "UNKNOWN_USER_TICKETS",
};

export const interactionStatusLabels = Object.freeze({
  [InteractionStatus2Enum.ONGOING]: "AI Ongoing",
  [InteractionStatus2Enum.VA_CLOSED]: "AI Closed",
  [InteractionStatus2Enum.TICKET_CLOSED]: "Closed Ticket",
  [InteractionStatus2Enum.TICKET_ON_HOLD]: "On Hold Ticket",
  [InteractionStatus2Enum.TICKET]: "Open Ticket",
  [InteractionStatus2Enum.SOFT_ALERT]: "Soft Alert",
  [InteractionStatus2Enum.TICKET_UNKNOWN_USER]: "Unknown User Ticket",
});

export const statusBadgeConfig = {
  [InteractionPageEnum.ALL_TICKETS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET],
      theme: "red",
      value: InteractionStatus2Enum.TICKET,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_ON_HOLD],
      theme: "gray",
      value: InteractionStatus2Enum.TICKET_ON_HOLD,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_CLOSED],
      theme: "green",
      value: InteractionStatus2Enum.TICKET_CLOSED,
    },
  ],
  [InteractionPageEnum.MY_TICKETS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET],
      theme: "red",
      value: InteractionStatus2Enum.TICKET,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_ON_HOLD],
      theme: "gray",
      value: InteractionStatus2Enum.TICKET_ON_HOLD,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_CLOSED],
      theme: "green",
      value: InteractionStatus2Enum.TICKET_CLOSED,
    },
  ],
  [InteractionPageEnum.MY_TEAMS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET],
      theme: "red",
      value: InteractionStatus2Enum.TICKET,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_ON_HOLD],
      theme: "gray",
      value: InteractionStatus2Enum.TICKET_ON_HOLD,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_CLOSED],
      theme: "green",
      value: InteractionStatus2Enum.TICKET_CLOSED,
    },
  ],
  [InteractionPageEnum.MY_DEPARTMENTS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET],
      theme: "red",
      value: InteractionStatus2Enum.TICKET,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_ON_HOLD],
      count: "9", // TODO hadrcode
      theme: "gray",
      value: InteractionStatus2Enum.TICKET_ON_HOLD,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_CLOSED],
      theme: "green",
      value: InteractionStatus2Enum.TICKET_CLOSED,
    },
  ],
  [InteractionPageEnum.ALL_SOFT_ALERTS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.SOFT_ALERT],
      theme: "yellow",
      value: InteractionStatus2Enum.SOFT_ALERT,
    },
  ],
  [InteractionPageEnum.MY_SOFT_ALERTS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.SOFT_ALERT],
      theme: "yellow",
      value: InteractionStatus2Enum.SOFT_ALERT,
    },
  ],
  [InteractionPageEnum.ALL_INTERACTIONS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.ONGOING],
      value: InteractionStatus2Enum.ONGOING,
      theme: "green", // TODO SCRUM1-1611 was gray, set green
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.VA_CLOSED],
      value: InteractionStatus2Enum.VA_CLOSED,
      theme: "green",
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.SOFT_ALERT],
      theme: "yellow",
      value: InteractionStatus2Enum.SOFT_ALERT,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET],
      theme: "red",
      value: InteractionStatus2Enum.TICKET,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_ON_HOLD],
      theme: "gray",
      value: InteractionStatus2Enum.TICKET_ON_HOLD,
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.TICKET_CLOSED],
      theme: "green",
      value: InteractionStatus2Enum.TICKET_CLOSED,
    },
  ],
  [InteractionPageEnum.VA_INTERACTIONS]: [
    {
      label: interactionStatusLabels[InteractionStatus2Enum.ONGOING],
      value: InteractionStatus2Enum.ONGOING,
      theme: "green", // TODO SCRUM1-1611 was gray, set green
    },
    {
      label: interactionStatusLabels[InteractionStatus2Enum.VA_CLOSED],
      value: InteractionStatus2Enum.VA_CLOSED,
      theme: "green",
    },
  ],
};

export const InteractionReplyMode2Enum = Object.freeze({
  REPLY_ALL: "Reply All",
  REPLY: "Reply",
  FORWARD: "Forward",
});

export const replyOptions = [
  {
    text: InteractionReplyMode2Enum.REPLY_ALL,
    value: InteractionReplyMode2Enum.REPLY_ALL,
  },
  {
    text: InteractionReplyMode2Enum.REPLY,
    value: InteractionReplyMode2Enum.REPLY,
  },
  {
    text: InteractionReplyMode2Enum.FORWARD,
    value: InteractionReplyMode2Enum.FORWARD,
  },
];

export const RecipientTypeEnum = Object.freeze({
  TO: "to",
  CC: "cc",
  BCC: "bcc",
});

export const interactionStatusDropDownOptions = Object.freeze({
  [InteractionStatus2Enum.TICKET_ON_HOLD]: {
    text: interactionStatusLabels[InteractionStatus2Enum.TICKET_ON_HOLD],
    value: InteractionStatus2Enum.TICKET_ON_HOLD,
  },
  [InteractionStatus2Enum.ONGOING]: {
    text: interactionStatusLabels[InteractionStatus2Enum.ONGOING],
    value: InteractionStatus2Enum.ONGOING,
  },
  [InteractionStatus2Enum.SOFT_ALERT]: {
    text: interactionStatusLabels[InteractionStatus2Enum.SOFT_ALERT],
    value: InteractionStatus2Enum.SOFT_ALERT,
  },
  [InteractionStatus2Enum.TICKET]: {
    text: interactionStatusLabels[InteractionStatus2Enum.TICKET],
    value: InteractionStatus2Enum.TICKET,
  },
  [InteractionStatus2Enum.TICKET_CLOSED]: {
    text: interactionStatusLabels[InteractionStatus2Enum.TICKET_CLOSED],
    value: InteractionStatus2Enum.TICKET_CLOSED,
  },
  [InteractionStatus2Enum.VA_CLOSED]: {
    text: interactionStatusLabels[InteractionStatus2Enum.VA_CLOSED],
    value: InteractionStatus2Enum.VA_CLOSED,
  },
});

const interactionStatusDropDownOptionsConfigForAllPagesUnderTickets = {
  [InteractionStatus2Enum.TICKET]:
    interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
  [InteractionStatus2Enum.TICKET_ON_HOLD]:
    interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET_ON_HOLD],
  [InteractionStatus2Enum.TICKET_CLOSED]:
    interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET_CLOSED],
};

// This is now the source truth of defining what any given Status can switch to
export const statusToOptionsMapping = {
  [InteractionStatus2Enum.ONGOING]: {
    [InteractionStatus2Enum.TICKET]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
    [InteractionStatus2Enum.VA_CLOSED]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.VA_CLOSED],
  },
  [InteractionStatus2Enum.VA_CLOSED]: {
    [InteractionStatus2Enum.TICKET]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
  },
  [InteractionStatus2Enum.SOFT_ALERT]: {
    [InteractionStatus2Enum.VA_CLOSED]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.VA_CLOSED],
    [InteractionStatus2Enum.TICKET]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
  },
  [InteractionStatus2Enum.TICKET]: {
    [InteractionStatus2Enum.TICKET_ON_HOLD]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET_ON_HOLD],
    [InteractionStatus2Enum.TICKET_CLOSED]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET_CLOSED],
  },
  [InteractionStatus2Enum.TICKET_CLOSED]: {
    [InteractionStatus2Enum.TICKET]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
  },
  [InteractionStatus2Enum.TICKET_ON_HOLD]: {
    [InteractionStatus2Enum.TICKET]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
    [InteractionStatus2Enum.TICKET_CLOSED]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET_CLOSED],
  },
};

const interactionStatusDropDownOptionsConfigForAllSoftAllertPages = {
  [InteractionStatus2Enum.SOFT_ALERT]:
    interactionStatusDropDownOptions[InteractionStatus2Enum.SOFT_ALERT],
  [InteractionStatus2Enum.VA_CLOSED]:
    interactionStatusDropDownOptions[InteractionStatus2Enum.VA_CLOSED],
  [InteractionStatus2Enum.TICKET]:
    interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
};

export const interactionStatusDropDownOptionsConfig = {
  [InteractionPageEnum.ALL_TICKETS]:
    interactionStatusDropDownOptionsConfigForAllPagesUnderTickets,
  [InteractionPageEnum.MY_TICKETS]:
    interactionStatusDropDownOptionsConfigForAllPagesUnderTickets,
  [InteractionPageEnum.MY_TEAMS]:
    interactionStatusDropDownOptionsConfigForAllPagesUnderTickets,
  [InteractionPageEnum.MY_DEPARTMENTS]:
    interactionStatusDropDownOptionsConfigForAllPagesUnderTickets,
  [InteractionPageEnum.MY_DRAFTS]:
    interactionStatusDropDownOptionsConfigForAllPagesUnderTickets,
  [InteractionPageEnum.ALL_SOFT_ALERTS]:
    interactionStatusDropDownOptionsConfigForAllSoftAllertPages,
  [InteractionPageEnum.MY_SOFT_ALERTS]:
    interactionStatusDropDownOptionsConfigForAllSoftAllertPages,
  [InteractionPageEnum.ALL_INTERACTIONS]: {
    [InteractionStatus2Enum.ONGOING]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.ONGOING],
    [InteractionStatus2Enum.VA_CLOSED]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.VA_CLOSED],
    [InteractionStatus2Enum.TICKET]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
    [InteractionStatus2Enum.TICKET_ON_HOLD]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET_ON_HOLD],
    [InteractionStatus2Enum.TICKET_CLOSED]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET_CLOSED],
  },
  [InteractionPageEnum.VA_INTERACTIONS]: {
    [InteractionStatus2Enum.ONGOING]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.ONGOING],
    [InteractionStatus2Enum.VA_CLOSED]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.VA_CLOSED],
    [InteractionStatus2Enum.TICKET]:
      interactionStatusDropDownOptions[InteractionStatus2Enum.TICKET],
  },
};

export const interactionStatusOptions = Object.freeze([
  {
    text: interactionStatusLabels[InteractionStatus2Enum.ONGOING],
    value: InteractionStatus2Enum.ONGOING,
  },
  {
    text: interactionStatusLabels[InteractionStatus2Enum.SOFT_ALERT],
    value: InteractionStatus2Enum.SOFT_ALERT,
  },
  {
    text: interactionStatusLabels[InteractionStatus2Enum.TICKET],
    value: InteractionStatus2Enum.TICKET,
  },
  {
    text: interactionStatusLabels[InteractionStatus2Enum.TICKET_CLOSED],
    value: InteractionStatus2Enum.TICKET_CLOSED,
  },
  {
    text: interactionStatusLabels[InteractionStatus2Enum.VA_CLOSED],
    value: InteractionStatus2Enum.VA_CLOSED,
  },
]);

export const departmentDropdownOptions = [
  {
    text: "All",
    value: InteractionDepartmentEnum.ALL,
  },
  {
    text: "Accounting",
    value: InteractionDepartmentEnum.ACCOUNTING,
  },
  {
    text: "Business",
    value: InteractionDepartmentEnum.BUSINESS,
  },
  {
    text: "Development",
    value: InteractionDepartmentEnum.DEVELOPMENT,
  },
  {
    text: "Sales",
    value: InteractionDepartmentEnum.SALES,
  },
  {
    text: "IT",
    value: InteractionDepartmentEnum.IT,
  },
];

export const interactionStatusesDictionary =
  createDictionaryFromDropdownOptions(interactionStatusOptions);

export const departmentsDictionary = createDictionaryFromDropdownOptions(
  departmentDropdownOptions
);

// Status enum for main gaps, matching PV2 backend.
// Whether recommendation has been seen is user-dependent and hence not included in backend state.
// Manual resolved should be considered ignored because endgoal is that system can
// answer, not that you put in the data already.
// Mapping of enum to clearer names done in component, esp if we want to change wording.
export const ContentGapStatusEnum = Object.freeze({
  ACTIONABLE: "ACTIONABLE",  // Content gap that needs attention, default state
  ASSIGNED: "ASSIGNED",  // Content gap that has been assigned to department for resolution
  IGNORED: "IGNORED",  // Content gap that has been marked as ignored by user
  RESOLVED: "RESOLVED",  // Content gap that has been resolved
});

export const PLACEHOLDER_UUID = "00000000-0000-0000-0000-000000000000"

export const TicketDFAStates = Object.freeze({
  INITIAL_STATE: "INITIAL_STATE",
  S0_TICKET_CREATED: "S0_TICKET_CREATED",
  S1_WAITING_FOR_WEBFORM1: "S1_WAITING_FOR_WEBFORM1",
  S2_WAITING_FOR_WEBFORM2: "S2_WAITING_FOR_WEBFORM2",
  S3_TICKET_OPEN_WAITING_SUPPORT_REPLY: "S3_TICKET_OPEN_WAITING_SUPPORT_REPLY",  
  S4_TICKET_OPEN_WAITING_USER_REPLY: "S4_TICKET_OPEN_WAITING_USER_REPLY",
  S5_TICKET_OPEN_WAITING_SUPPORT_REPLY_REMINDER_SENT: "S5_TICKET_OPEN_WAITING_SUPPORT_REPLY_REMINDER_SENT",
  S6_TICKET_OPEN_WAITING_USER_REPLY_REMINDER_SENT: "S6_TICKET_OPEN_WAITING_USER_REPLY_REMINDER_SENT",
  S7_PARTIAL_TICKET_CLOSED: "S7_PARTIAL_TICKET_CLOSED",
  S8_TICKET_CLOSED: "S8_TICKET_CLOSED",
  S9_TICKET_CLOSED_NO_TICKET: "S9_TICKET_CLOSED_NO_TICKET",
})

export const ThreadDFAStates = Object.freeze({
  S0_THREAD_CREATED: "S0_THREAD_CREATED",
  S1_ACTIVE: "S1_ACTIVE",
  S2_PENDING_CLOSE: "S2_PENDING_CLOSE",
  S3_CLOSED: "S3_CLOSED", 
  S4_SOFT_ALERT: "S4_SOFT_ALERT",
  S6_SOFT_ALERT_PENDING_CLOSE: "S6_SOFT_ALERT_PENDING_CLOSE",
  S5_SOFT_ALERT_TERMINAL: "S5_SOFT_ALERT_TERMINAL", 
  T1_TICKET_INTENT: "T1_TICKET_INTENT",
  T2_TICKET_ACKNOWLEDGED_OPEN: "T2_TICKET_ACKNOWLEDGED_OPEN", 
  T3_TICKET_PARTIAL: "T3_TICKET_PARTIAL", 
})

export const TicketStatuses = Object.freeze({
  OPEN: "open",
  CLOSED: "closed",
  DRAFT: "draft",
  REOPENED: "reopened",
  RESCINDED: "rescinded",
  ONGOING: "ongoing",
  PARTIALLY_CLOSED: "partially-closed",
})

export const TicketStatusOptions = Object.freeze({
  [TicketStatuses.OPEN]: {
    text: "Open",
    value: TicketStatuses.OPEN,
    color: "red",
  },
  [TicketStatuses.CLOSED]: {
    text: "Closed",
    value: TicketStatuses.CLOSED,
    color: "green",
  },
  [TicketStatuses.DRAFT]: {
    text: "Draft",
    value: TicketStatuses.DRAFT,
    color: "yellow",
  },
  [TicketStatuses.REOPENED]: {
    text: "Reopened",
    value: TicketStatuses.REOPENED,
    color: "red",
  },
  [TicketStatuses.RESCINDED]: {
    text: "Rescinded",
    value: TicketStatuses.RESCINDED,
    color: "red",
  },
  [TicketStatuses.ONGOING]: {
    text: "Ongoing",
    value: TicketStatuses.ONGOING,
    color: "red",
  },
  [TicketStatuses.PARTIALLY_CLOSED]: {
    text: "Partially Closed",
    value: TicketStatuses.PARTIALLY_CLOSED,
    color: "yellow",
  },
})

export const ThreadStatusOptions = Object.freeze({
  [InteractionStatus2Enum.ONGOING]: {
    text: interactionStatusLabels[InteractionStatus2Enum.ONGOING],
    value: InteractionStatus2Enum.ONGOING,
    color: "green"
  },
  [InteractionStatus2Enum.VA_CLOSED]: {
    text: interactionStatusLabels[InteractionStatus2Enum.VA_CLOSED],
    value: InteractionStatus2Enum.VA_CLOSED,
    color: "green"
  },
  [InteractionStatus2Enum.SOFT_ALERT]: {
    text: interactionStatusLabels[InteractionStatus2Enum.SOFT_ALERT],
    value: InteractionStatus2Enum.SOFT_ALERT,
    color: "yellow"
  },
  [InteractionStatus2Enum.TICKET]: {
    text: "Tickets",
    value: InteractionStatus2Enum.TICKET,
    color: "red",
  }
})


// for some reason backend has onhold and resumed but frontend doesen't 
export const TicketStatusKeys = [
  TicketStatuses.OPEN,
  TicketStatuses.CLOSED,
  TicketStatuses.DRAFT,
  TicketStatuses.REOPENED,
  TicketStatuses.RESCINDED,
  TicketStatuses.ONGOING,
  TicketStatuses.PARTIALLY_CLOSED,
  "onhold",
  "resumed",
];

export const ThreadStatusKeys = Object.keys(ThreadStatusOptions);

export const AllThreadStatusKeys = Array.from(
  new Set([...TicketStatusKeys, ...ThreadStatusKeys]),
);

export const MessengerPageCategoryEnum = {
  CHAT: "CHAT",
  MY_TICKETS: "MY_TICKETS",
};

export const ThreadStatusEnum = Object.freeze({
  AI_ONGOING: "AI Ongoing",
  NEW: "New",
  OPEN: "Open",
  PENDING_USER_REPLY: "Pending User Reply",
  ONHOLD: "On Hold",
  PENDING_FORM_SUBMISSION: "Pending Form Submission",
  USER_CLOSED: "User Closed",
  SUPPORT_CLOSED: "Support Closed",
  AUTO_CLOSED: "Auto Closed",
  SOFT_ALERT: "Soft Alert",
  AI_CLOSED: "AI Closed",
  ESCALATED: "Escalated",
  REOPENED: "Reopened",
  UNKNOWN: "Unknown",
})

// Need this so we know what to make for the filters for each page, probably put this directly in the inbox component
export const TicketCategoryStatusEnum = Object.freeze({
  NEW: "New",
  OPEN: "Open",
  PENDING_USER_REPLY: "Pending User Reply",
  ONHOLD: "On Hold",
  PENDING_FORM_SUBMISSION: "Pending Form Submission",
  USER_CLOSED: "User Closed",
  SUPPORT_CLOSED: "Support Closed",
  AUTO_CLOSED: "Auto Closed",
  ESCALATED: "Escalated",
  REOPENED: "Reopened",
})

// Need this so we know what to make for the filters for each page, probably put this directly in the inbox component
// Need a better name
export const ThreadCategoryStatusEnum = Object.freeze({
  AI_ONGOING: "AI Ongoing",
  AI_CLOSED: "AI Closed",
  SOFT_ALERT: "Soft Alert",
  TICKETS: "Tickets",
})

export const SoftAlertCategoryStatusEnum = Object.freeze({
  SOFT_ALERT: "Soft Alert",
})

// make sure these are different from TicketCategoryStatusEnum 
export const EndUserTicketCategoryStatusEnum = Object.freeze({
  OPEN: "Open",
  AWAITING_YOUR_REPLY: "Awaiting Your Reply",
  CLOSED_BY_YOU: "Closed by You",
  CLOSED_BY_SUPPORT: "Closed by Support",
  PENDING_FORM_SUBMISSION: "Pending Form Submission",
})

export const EndUserInboxStatusMapping = Object.freeze({
  [EndUserTicketCategoryStatusEnum.OPEN]: [ 
    ThreadStatusEnum.NEW,
    ThreadStatusEnum.REOPENED,
    ThreadStatusEnum.ESCALATED,
    ThreadStatusEnum.OPEN,
    ThreadStatusEnum.ONHOLD,
  ],
  [EndUserTicketCategoryStatusEnum.AWAITING_YOUR_REPLY]: [
    ThreadStatusEnum.PENDING_USER_REPLY
  ],
  [EndUserTicketCategoryStatusEnum.PENDING_FORM_SUBMISSION]: [
    ThreadStatusEnum.PENDING_FORM_SUBMISSION,
  ],
  [EndUserTicketCategoryStatusEnum.CLOSED_BY_YOU]: [
    ThreadStatusEnum.USER_CLOSED
  ],
  [EndUserTicketCategoryStatusEnum.CLOSED_BY_SUPPORT]: [
    ThreadStatusEnum.SUPPORT_CLOSED,
    ThreadStatusEnum.AUTO_CLOSED,
  ],
})

export const InteractionCategoryToThreadStatusMap = {
  [InteractionPageEnum.ALL_TICKETS]: TicketCategoryStatusEnum,
  [InteractionPageEnum.MY_TICKETS]: TicketCategoryStatusEnum,
  [InteractionPageEnum.MY_TEAMS]: TicketCategoryStatusEnum,
  [InteractionPageEnum.MY_DEPARTMENTS]: TicketCategoryStatusEnum,
  [InteractionPageEnum.MY_DRAFTS]: TicketCategoryStatusEnum,

  [InteractionPageEnum.ALL_SOFT_ALERTS]: SoftAlertCategoryStatusEnum,
  [InteractionPageEnum.MY_SOFT_ALERTS]: SoftAlertCategoryStatusEnum,

  [InteractionPageEnum.ALL_INTERACTIONS]: ThreadCategoryStatusEnum,
  [InteractionPageEnum.VA_INTERACTIONS]: {
    AI_ONGOING: "AI Ongoing",
    AI_CLOSED: "AI Closed",
  },
}
